module["exports"] = [
  "Anna",
  "Eva",
  "Maria",
  "Karin",
  "Sara",
  "Kristina",
  "Lena",
  "Emma",
  "Kerstin",
  "Marie",
  "Malin",
  "Ingrid",
  "Jenny",
  "Hanna",
  "Linda",
  "Annika",
  "Susanne",
  "Elin",
  "Monica",
  "Birgitta",
  "Sofia",
  "Johanna",
  "Inger",
  "Carina",
  "Elisabeth",
  "Julia",
  "Ulla",
  "Katarina",
  "Linnéa",
  "Emelie",
  "Ida",
  "Helena",
  "Camilla",
  "Åsa",
  "Anette",
  "Sandra",
  "Gunilla",
  "Anita",
  "Maja",
  "Marianne",
  "Margareta",
  "Amanda",
  "Anneli",
  "Therese",
  "Ann",
  "Josefin",
  "Cecilia",
  "Jessica",
  "Helen",
  "Lisa",
  "Matilda",
  "Caroline",
  "Alice",
  "Frida",
  "Ulrika",
  "Elsa",
  "Barbro",
  "Siv",
  "Rebecca",
  "Madeleine",
  "Klara",
  "Ebba",
  "Sofie",
  "Isabelle",
  "Agneta",
  "Gun",
  "Wilma",
  "Lina",
  "Berit",
  "Pia",
  "Ella",
  "Ellen",
  "Yvonne",
  "Louise",
  "Astrid",
  "Moa",
  "Olivia",
  "Nathalie",
  "Mona",
  "Agnes",
  "Emilia",
  "Alexandra",
  "Alva",
  "Britt",
  "Erika",
  "Viktoria",
  "Ann-Christin",
  "Felicia",
  "Ann-Marie",
  "Sonja",
  "Britt-Marie",
  "Pernilla",
  "Lovisa",
  "Charlotte",
  "Linn",
  "Gunnel",
  "Nina",
  "Mikaela",
  "Karolina",
  "Lisbeth"
];